import React, { Component, Fragment } from "react"
import { Link } from "react-router-dom"
import { NamespacesConsumer as I18n } from "react-i18next"
import { Menu, Dropdown, List, Flag } from "semantic-ui-react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { typeLanguage } from "../language/multilingual"
import { Grid } from "semantic-ui-react"

//component
import { constMenu } from "../containers/ConstData/constMenu"
import Notification from "../components/Notification"
import ImageProfile from "../components/ImageProfile"
import { handlelocalstorageClear } from "../containers/Registration/PostMessage"

//material ui
import Divider from "@material-ui/core/Divider"
import Badge from "@material-ui/core/Badge"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import ClearIcon from "@material-ui/icons/Clear"

class MenuNavBarDesktop extends Component {
	constructor(props) {
		super(props)
		this.state = {
			language: localStorage.getItem("Language") === "en" ? "EN" : "TH",
			status: true
		}
	}
	handlei18n = (i18n, item) => {
		i18n.changeLanguage(item.value)
		if (item.value === "en") {
			this.setState({ language: "EN" })
			localStorage.setItem("Language", "en")
		} else {
			this.setState({ language: "TH" })
			localStorage.setItem("Language", "th")
		}
	}
	handlei18ndef = (i18n) => {
		i18n.changeLanguage(localStorage.getItem("Language"))
		this.setState({ status: false })
	}
	render() {
		const {
			classes,
			user,
			userInfo,
			activeItem,
			handleItemClick,
			handleClickOpen,
			logout_local,
			handlegetnotification,
			LastEvaluatedKey,
			notification,
			loading,
			notseen,
			open,
			handleopen
		} = this.props
		const { language, status } = this.state

		return (
			<I18n>
				{(t, { i18n }) => {
					if (status) {
						this.handlei18ndef(i18n)
					}
					return (
						<Menu secondary>
							<Menu.Item
								style={{
									padding: "0px 0px",
									background: "transparent"
								}}
								as={Link}
								to="/"
								name="Home"
								onClick={handleItemClick}
							>
								<LazyLoadImage
									alt="logo"
									src="/MMA Logo Guide-04.png"
									width="50px"
									height="50px"
								/>
							</Menu.Item>
							{/* <Menu.Item
								as={Link}
								to="/Features"
								name="Features"
								active={activeItem === "Features"}
								onClick={handleItemClick}
							>
								{t("NavBarDesktop.NavBarDesktopFeatures")}
							</Menu.Item>
							<Menu.Item
								as={Link}
								to="/Services"
								name="Services"
								active={activeItem === "Services"}
								onClick={handleItemClick}
							>
								{t("NavBarDesktop.NavBarDesktopServices")}
							</Menu.Item> */}

							{Object.keys(user).length === 0 ? (
								<Fragment>
									<Menu.Item
										as={Link}
										to="/GlobalProjects"
										name="Projects"
										active={activeItem === "Projects"}
										onClick={handleItemClick}
									>
										{t("NavBarDesktop.NavBarDesktopProjects")}
									</Menu.Item>
								</Fragment>
							) : (
								<Fragment>
									<Dropdown
										item
										text={t("NavBarDesktop.NavBarDesktopProjects")}
										name="Projects"
										onClick={handleItemClick}
									>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/GlobalProjects">
												{t("NavBarDesktop.NavBarDesktopGlobalProjects")}
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/MyProjects">
												{t("NavBarDesktop.NavBarDesktopMyProjects")}
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</Fragment>
							)}

							<Menu.Item
								as={Link}
								to="/Community"
								name="Community"
								active={activeItem === "Community"}
								onClick={handleItemClick}
							>
								{t("NavBarDesktop.NavBarDesktopCommunity")}
							</Menu.Item>
							<Menu.Item
								href="https://blogs.mixedmodel.academy/"
								name="Blogs"
								active={activeItem === "Blogs"}
								onClick={handleItemClick}
							>
								{t("Blogs.Blogs")}
							</Menu.Item>
							<Menu.Item
								as={Link}
								to="/Document/How-to-Create-a-Project-in-MMA/1"
								name="Guides"
								active={activeItem === "Guides"}
								onClick={handleItemClick}
							>
								{t("Menu.Document")}
							</Menu.Item>
							<Menu.Item
								as={Link}
								to="/Tutorial"
								name="Tutorial"
								active={activeItem === "Tutorial"}
								onClick={handleItemClick}
							>
								{t("NavBarDesktop.NavBarDesktopVideo")}
							</Menu.Item>

							<Menu.Menu position="right">
								<Dropdown item icon="th" name="menu" className="dropdownmain">
									<Dropdown.Menu className={"dropdownmenu"}>
										<div className="contianer_gridBox">
											<Grid columns={3}>
												{constMenu.map((item, i) => {
													return item.name === "Projects" &&
														Object.keys(user).length !== 0 ? (
														item.sub.map((itemsub, j) => {
															return (
																<Grid.Column key={j}>
																	<div className="icon_Menu">
																		<Link
																			to={itemsub.link}
																			className="Grid_Button"
																		>
																			<img
																				src={itemsub.icon}
																				width="50px"
																				height="auto"
																				alt={itemsub.name}
																				style={{ marginBottom: 10 }}
																			/>
																			{t(itemsub.namemenu)}
																		</Link>
																	</div>
																</Grid.Column>
															)
														})
													) : (
														<Grid.Column key={i}>
															<div className="icon_Menu">
																<Link to={item.link} className="Grid_Button">
																	<img
																		src={item.icon}
																		width="50px"
																		height="auto"
																		alt={item.name}
																		style={{ marginBottom: 10 }}
																	/>
																	{t(item.namemenu)}
																</Link>
															</div>
														</Grid.Column>
													)
												})}
											</Grid>
										</div>
									</Dropdown.Menu>
								</Dropdown>
								{Object.keys(user).length === 0 ? (
									<Fragment>
										<Menu.Item
											name="Sign in"
											active={activeItem === "signin"}
											onClick={(e) => handleClickOpen(e, "Sign in")}
										>
											{t("NavBarDesktop.NavBarDesktopSignIn")}
										</Menu.Item>

										<Menu.Item
											name="Sign up"
											active={activeItem === "signup"}
											onClick={(e) => handleClickOpen(e, "Sign up")}
										>
											{t("NavBarDesktop.NavBarDesktopSignUp")}
										</Menu.Item>
									</Fragment>
								) : (
									<Fragment>
										<Badge
											max={99}
											classes={{ badge: classes.badge }}
											className={classes.margin}
											badgeContent={notseen}
											color="secondary"
										>
											<Dropdown
												item
												icon="bell"
												direction="left"
												lazyLoad
												style={{
													padding: " .78571429em 0px",
													background: "transparent"
												}}
												onOpen={() => handleopen(undefined)}
												open={open}
											>
												<Dropdown.Menu
													style={{
														height: 338,
														minHeight: 338,
														zIndex: 2
													}}
												>
													<div>
														<Dropdown.Item
															className="close_dropdown"
															style={{
																display: "flex",
																justifyContent: "flex-end"
															}}
														>
															<ClearIcon
																onClick={() => handleopen(undefined)}
																style={{
																	color: "rgba(0, 0, 0, 0.87)",
																	cursor: "pointer"
																}}
															/>
														</Dropdown.Item>
													</div>
													{!loading && notification.length === 0 && (
														<div
															style={{
																color: "rgb(89, 89, 89)",
																display: "flex",
																justifyContent: "center"
															}}
														>
															{t("Subscription.nonotifications")}
														</div>
													)}
													<Dropdown.Menu scrolling>
														<List className={classes.root} selection>
															{notification.map((option, i) => (
																<Notification
																	key={i}
																	i={i}
																	t={t}
																	classes={classes}
																	option={option}
																	handleopen={this.handleopen}
																	{...this.props}
																/>
															))}
														</List>
														{!!LastEvaluatedKey &&
															(loading ? (
																<div style={{ textAlign: "center" }}>
																	<Button
																		disabled
																		aria-label="get_activity"
																		color="primary"
																		className={classes.button}
																	>
																		{t("button.loading")}
																	</Button>
																</div>
															) : (
																<div style={{ textAlign: "center" }}>
																	<Button
																		aria-label="get_activity"
																		color="primary"
																		className={classes.button}
																		onClick={() => handlegetnotification()}
																	>
																		{t("button.seemore")}
																	</Button>
																</div>
															))}
													</Dropdown.Menu>
												</Dropdown.Menu>
											</Dropdown>
										</Badge>
										<Dropdown
											item
											trigger={
												<Avatar alt="Remy Sharp" className={classes.avatar}>
													<ImageProfile
														width={"35px"}
														height={"35px"}
														userInfoImage={userInfo.image}
													/>
												</Avatar>
											}
											className="Dropdownprofile"
											name="Profile"
											onClick={handleItemClick}
											style={{
												background: "transparent",
												margin: 0
											}}
										>
											<Dropdown.Menu>
												<Dropdown.Item as={Link} to="/UserProfile">
													{t("NavBarDesktop.NavBarDesktopMyAccounts")}
												</Dropdown.Item>
												{/* <Dropdown.Item as={Link} to="#">
													{t("NavBarDesktop.NavBarDesktoppurchasehistory")}
												</Dropdown.Item> */}
												<Divider />

												<Dropdown.Item
													onClick={(e) => handleClickOpen(e, "Contact us")}
												>
													{t("NavBarDesktop.NavBarDesktopContactUs")}
												</Dropdown.Item>
												<Dropdown.Item
													onClick={(e) => {
														handlelocalstorageClear()
														logout_local()
														handleClickOpen(e, "Sign in")
													}}
												>
													{t("NavBarDesktop.NavBarDesktopLogout")}
												</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</Fragment>
								)}
								<Dropdown
									item
									text={language}
									icon=""
									name="Language"
									style={{
										background: "transparent",
										margin: 0
									}}
								>
									<Dropdown.Menu>
										{typeLanguage.map((item, i) => {
											return (
												<Dropdown.Item
													key={i}
													onClick={(event) => this.handlei18n(i18n, item)}
												>
													<Flag name={item.icon} /> {item.text}
												</Dropdown.Item>
											)
										})}
									</Dropdown.Menu>
								</Dropdown>
							</Menu.Menu>
						</Menu>
					)
				}}
			</I18n>
		)
	}
}
export default MenuNavBarDesktop
